const backgroundColours: Record<string, string> = {
    blue: 'bg-blue-500! dark:bg-blue-400!',
    green: 'bg-green-500! dark:bg-green-400!',
    orange: 'bg-orange-500! dark:bg-orange-400!',
    red: 'bg-red-500! dark:bg-red-400!',
    yellow: 'bg-yellow-500! dark:bg-yellow-400!'
};
const foregroundColours: Record<string, string> = {
    blue: 'text-blue-500! dark:text-blue-400!',
    green: 'text-green-500! dark:text-green-400!',
    orange: 'text-orange-500! dark:text-oranger-400!',
    red: 'text-red-500! dark:text-red-400!',
    sky: 'text-sky-500! dark:text-sky-400!',
    yellow: 'text-yellow-500! dark:text-yellow-400!'
};
const inlineColours: Record<string, string> = {
    blue: 'light-dark(var(--p-blue-500), var(--p-blue-400))',
    green: 'light-dark(var(--p-green-500), var(--p-green-400))',
    orange: 'light-dark(var(--p-orange-500), var(--p-orange-400))',
    red: 'light-dark(var(--p-red-500), var(--p-red-400))'
};

export function classBackground(name: string): string {
    if (!name) throw new Error('Colour name is required');
    if (!backgroundColours[name]) throw new Error(`Colour '${name}' not found`);

    return backgroundColours[name];
}

export function classForeground(name: string): string {
    if (!name) throw new Error('Colour name is required');
    if (!foregroundColours[name]) throw new Error(`Colour '${name}' not found`);

    return foregroundColours[name];
}

export function inline(name: string): string {
    if (!name) throw new Error('Colour name is required');
    if (!inlineColours[name]) throw new Error(`Colour '${name}' not found`);

    return inlineColours[name];
}
